/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-prototype-builtins */
/* eslint-disable valid-typeof */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, memo, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import EmojiPicker from "emoji-picker-react";
import {
  getUpdateUnreadChatMessage,
  timestampToDateTime,
} from "../Helpers/common";
import UserInputMessageArea from "../chatboard/userInputMessageArea";
import ChatDelete from "../models/ChatDelete";
import UserProfilePopOver from "../models/userProfilePopOver";
import {
  OnClickOutside,
  UrlPreview,
  onEmojiClickCommonHandler,
  pinnedUserProfileHover,
  previewLinkIcon,
  userProfileHover,
} from "../Helpers/chatCommon";
import AttachmentsFiles from "../chatboard/attachmentFile";
import ReactionUserPopOver from "../models/reactionUsersPopOver";
import ChatUnpinAlert from "../models/ChatUnpinAlert";
import { useEmojiPicker } from "../../hooks/useEmojiPicker";
import { createPortal } from "react-dom";
import { EmojiIcon, PinFillIcon } from "../../assets/icons/svg";

const ThreadBoardOutgoing = ({
  value,
  userInfo,
  firstMessage,
  threadCount,
  lastMessage,
  editMessageHandler,
  messageEditId,
  moreActionHandler,
  moreActionEnableId,
  senderID,
  setMoreActionEnableId,
  setStopScrollBottom,
  handlePinnedMessage,
}) => {
  const { emojiOpen, emojiPosition, emojiPickerRef, openPicker, closePicker } =
    useEmojiPicker();

  let IsNewLineExist = null;

  if (
    value.message !== "c2-attach-files" &&
    value.message !== "c2-attach-recording-file"
  ) {
    IsNewLineExist = /\r|\n/.exec(value.message);
  }

  const actionRef = useRef(null);

  const { authUserDetail, call, chat } = useSelector((state) => state);
  const { authSessionUser } = authUserDetail || {};
  const { allAttendeeList } = call || {};

  const {
    userProfileHoverId,
    deletedMessageIds,
    msgMentionId,
    msgMentionUser,
    isMentionInThread,
    selectedLanguage,
    popupClass,
    pinnedByUserProfileId,
    deleteChatData,
  } = chat || {};

  const [selectedReactionUser, setSelectedReactionUser] = useState({});

  const [showDelete, setShowDelete] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const [showUnpin, setShowUnpin] = useState(false);
  const [unpinData, setUnpinData] = useState({});

  useEffect(() => {
    if (deleteChatData?.messageID) {
      let deletedID = document.getElementById(deleteChatData.messageID);
      if (deletedID) {
        deletedID.classList.add("chat_row_hide");
      }
    }
  }, [deleteChatData]);

  const showMessage = (value) => {
    if (messageEditId === value.id) {
      return (
        <UserInputMessageArea
          componentType="editMessage"
          editableData={value}
          editMessageHandler={editMessageHandler}
        />
      );
    } else {
      if (
        value.attachments !== undefined &&
        value.attachments.length > 0 &&
        (value.message === "c2-attach-files" ||
          value.message === "c2-attach-recording-file")
      ) {
        if (
          (value.message === "c2-attach-recording-file" &&
            value.senderID === authSessionUser?.user_id) ||
          value.message === "c2-attach-files"
        ) {
          return (
            <div className="d-flex file_send_info gap-10 flex-wrap">
              {value?.attachment_caption ? (
                <div className="file_send_info_inner">
                  <div className="d-flex flex-wrap gap-y-10">
                    {value.attachments.map(
                      (attachmentItem, attachmentIndex) => {
                        return (
                          <div className="w-100" key={attachmentIndex}>
                            {/* eslint-disable-next-line indent */}
                            {/* eslint-disable-next-line indent */}
                            <AttachmentsFiles
                              attachmentItem={attachmentItem}
                              messageDetail={value}
                            />
                          </div>
                        );
                      },
                    )}
                  </div>

                  <div>
                    {value?.attachment_caption && (
                      <span>
                        <p
                          className="break-words"
                          dangerouslySetInnerHTML={{
                            __html: value?.attachment_caption,
                          }}
                        />
                      </span>
                    )}
                  </div>
                </div>
              ) : (
                value.attachments.map((attachmentItem, attachmentIndex) => {
                  return (
                    <div className="w-100" key={attachmentIndex}>
                      {/* eslint-disable-next-line indent */}
                      {/* eslint-disable-next-line indent */}
                      <AttachmentsFiles
                        attachmentItem={attachmentItem}
                        messageDetail={value}
                      />
                    </div>
                  );
                })
              )}
            </div>
          );
        } else {
          return false;
        }
      } else {
        if (IsNewLineExist !== null) {
          const newMessage =
            value.preview &&
            Array.isArray(value.preview) &&
            value.preview.length > 0
              ? value.message_array.join(" ")
              : value.message.replace(/ /g, "&nbsp;");

          const lengthOfSplitMessage = newMessage?.split("\n").length;
          return (
            <>
              {newMessage?.split("\n").map((str, index) => (
                <>
                  <div
                    key={index}
                    className="d-flex file_send_info gap-10 flex-wrap share-link"
                  >
                    <p
                      className="break-words"
                      dangerouslySetInnerHTML={{ __html: str }}
                    />
                    {previewLinkIcon(value)}

                    {/* {msgMentionId === value.msgUniqueID &&
                      value.type === "group" &&
                      isMentionInThread && (
                        <UserProfilePopOver
                          userInfo={
                            msgMentionId === value.msgUniqueID
                              ? allAttendeeList?.find(
                                  (userItem) =>
                                    userItem?.user_id === msgMentionUser,
                                ) ?? {}
                              : userInfo
                          }
                          popupClass={popupClass}
                          selectedLanguage={selectedLanguage}
                        />
                      )} */}
                    {messageEditId !== value.id &&
                      value.edited === true &&
                      index === lengthOfSplitMessage - 1 && (
                        <p className="edit_message_display">(edited)</p>
                      )}
                  </div>
                </>
              ))}
              {value?.preview ? UrlPreview(value?.preview) : null}
            </>
          );
        } else {
          return (
            <>
              <div className="d-flex file_send_info gap-10 flex-wrap">
                <p
                  className="break-words"
                  dangerouslySetInnerHTML={{
                    __html:
                      value.preview &&
                      Array.isArray(value.preview) &&
                      value.preview.length > 0
                        ? value.message_array.join(" ")
                        : value.message,
                  }}
                />
                {previewLinkIcon(value)}
                {/* <p className="break-words"> {value.message}</p> */}

                {/* {msgMentionId === value.msgUniqueID &&
                  value.type === "group" &&
                  isMentionInThread && (
                    <UserProfilePopOver
                      userInfo={
                        msgMentionId === value.msgUniqueID
                          ? allAttendeeList?.find(
                              (userItem) =>
                                userItem?.user_id === msgMentionUser,
                            ) ?? {}
                          : userInfo
                      }
                      popupClass={popupClass}
                      selectedLanguage={selectedLanguage}
                    />
                  )} */}
                {messageEditId !== value.id && value.edited === true && (
                  <p className="edit_message_display">(edited)</p>
                )}
              </div>

              {value?.preview ? UrlPreview(value?.preview) : null}
            </>
          );
        }
      }
    }
  };

  const onEmojiClick = (emojiObject) => {
    onEmojiClickCommonHandler(emojiObject, value);
  };

  const addRemoveEmoji = (emojiItem, value) => {
    onEmojiClickCommonHandler(emojiItem, value);
  };

  OnClickOutside(actionRef, () => setMoreActionEnableId(""));

  const isUserOnline = React.useMemo(() => {
    return allAttendeeList?.find((item) => item.user_id === value.senderID)
      ?.online
      ? true
      : false;
  }, [allAttendeeList, value.senderID]);

  let pinned_by_username = "";
  if (value?.pinned_by) {
    allAttendeeList?.some((v) => {
      if (senderID === value.pinned_by) {
        pinned_by_username = "you";
      } else if (v.user_id === value.pinned_by) {
        pinned_by_username = v.name;
      }
    });
  }

  const handleUnpinAlert = (value) => {
    if (value?.pinned) {
      setUnpinData(value);
      setShowUnpin(true);
    } else {
      handlePinnedMessage(value);
    }
  };

  return (
    <>
      <div
        className={`chat_row thread_row ${lastMessage === true ? "mb-0" : ""} ${
          deletedMessageIds?.includes(value?.id) ? "chat_row_hide" : ""
        } ${value?.pinned && "highlight"}`}
        id={value.id}
        key={value.id}
        onMouseLeave={() => {
          userProfileHover({});
          pinnedUserProfileHover();
        }}
      >
        <div className="w-100 d-flex flex-column max-w-100">
          {value?.pinned && (
            <div className="d-flex align-items-center">
              <div className="pinned-icon">
                <PinFillIcon
                  className="bi bi-pin-angle-fill flip-icon text-orange-light"
                  width={14}
                  height={14}
                />
              </div>
              <span>
                &nbsp;Pinned by&nbsp;
                {pinned_by_username === "you" ? (
                  pinned_by_username
                ) : (
                  <a
                    onMouseEnter={(e) =>
                      pinnedUserProfileHover(e, value.pinned_by, value.id)
                    }
                  >
                    <strong>{` ${pinned_by_username}`}</strong>
                  </a>
                )}
              </span>
            </div>
          )}
          <div className="d-flex">
            <div
              className="avatar "
              onMouseEnter={() => userProfileHover(value.id, true)}
            >
              <img
                className="h-100"
                src={`${
                  authSessionUser.user_profile_image ? (
                    authSessionUser.user_profile_image
                  ) : (
                    <svg viewBox="3 2 18 19">
                      <path
                        fill="#425b76"
                        d="M7.5 6.5C7.5 8.981 9.519 11 12 11s4.5-2.019 4.5-4.5S14.481 2 12 2 7.5 4.019 7.5 6.5zM20 21h1v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h17z"
                      ></path>
                    </svg>
                  )
                }`}
              ></img>
              <span className={`status ${isUserOnline && "online"}`}></span>
            </div>
            {(userProfileHoverId?.thread === value.id ||
              (msgMentionId === value.msgUniqueID &&
                value.type === "group" &&
                isMentionInThread)) && (
              <UserProfilePopOver
                userInfo={
                  msgMentionId === value.msgUniqueID
                    ? allAttendeeList?.find(
                        (userItem) => userItem?.user_id === msgMentionUser,
                      ) ?? {}
                    : pinnedByUserProfileId === value.pinned_by
                    ? allAttendeeList?.find(
                        (userItem) =>
                          userItem?.user_id === pinnedByUserProfileId,
                      ) ?? {}
                    : userInfo
                }
                popupClass={popupClass}
                selectedLanguage={selectedLanguage}
              />
            )}
            <div
              className={`bubble inner-bubble ${
                value.isReply === true && "reply"
              }`}
            >
              {value.isReply === true && (
                <h3 className="Name-messenger">{userInfo.name} </h3>
              )}
              <div className={`${value.isReply === true && "reply-inner"}`}>
                {value.isReply === true ? (
                  <h3 className="Name-messenger flex-column align-items-start">
                    <div>
                      <p
                        className="break-words text-grey"
                        dangerouslySetInnerHTML={{ __html: value.earlyMessage }}
                      />
                      {/* {msgMentionId === value.msgUniqueID &&
                        value.type === "group" &&
                        isMentionInThread && (
                          <UserProfilePopOver
                            key={value?.id}
                            userInfo={
                              msgMentionId === value.msgUniqueID
                                ? allAttendeeList?.find(
                                    (userItem) =>
                                      userItem?.user_id === msgMentionUser,
                                  ) ?? {}
                                : userInfo
                            }
                            popupClass={popupClass}
                            selectedLanguage={selectedLanguage}
                          />
                        )} */}
                      <div className="time ml-0 mt-1">
                        {allAttendeeList?.find(
                          (findItem) =>
                            findItem.user_id === value.earlyMsgSenderID,
                        )?.name ?? ""}
                        , {timestampToDateTime(value.earlyMsgTimestamp)}
                      </div>
                    </div>
                  </h3>
                ) : (
                  <h3 className="Name-messenger">
                    {userInfo.name}{" "}
                    <div className="time">
                      {timestampToDateTime(value.timestamp)}
                    </div>
                  </h3>
                )}
              </div>
              {showMessage(value)}
            </div>
          </div>
        </div>

        <div
          className={`chat_actions ${
            moreActionEnableId === value.id ? "display_flex" : "display_none"
          }`}
        >
          <>
            <div className="chat_actions_span">
              <button
                type="submit"
                className="btn-icon justify-content-center"
                onClick={(e) => openPicker(e)}
              >
                <EmojiIcon width={19} height={19} />
              </button>

              {value.message !== "c2-attach-recording-file" && (
                <div className="dropdown">
                  <a
                    className="justify-content-center dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClick={() => {
                      moreActionHandler(value.id);
                    }}
                  >
                    <svg width="4px" viewBox="10 4 4 16">
                      <path
                        fill="#b8c0c9"
                        d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                      ></path>
                    </svg>
                  </a>

                  <ul
                    className="chat_actions_dropdown flex-column dropdown-menu"
                    aria-labelledby={`${"dropdownMenuButton"}`}
                    ref={actionRef}
                  >
                    {value.message !== "c2-attach-files" && (
                      <>
                        {/* <li
                          className="chat_actions_li"
                          onClick={() => {
                            replyHandler(value);
                            moreActionHandler("");
                          }}
                        >
                          <a className="chat_actions_tag">Reply</a>
                        </li> */}

                        <li
                          className="chat_actions_li"
                          onClick={() => {
                            editMessageHandler(value.id);
                            setStopScrollBottom(true);
                          }}
                        >
                          <a className="chat_actions_tag">Edit</a>
                        </li>
                      </>
                    )}
                    {!value?.parentMsg && (
                      <li
                        className="chat_actions_li"
                        onClick={() => {
                          setShowDelete(true);
                          setDeleteData(value);
                          moreActionHandler("");
                        }}
                      >
                        <a className="chat_actions_tag">Delete</a>
                      </li>
                    )}
                    <li
                      className="chat_actions_li"
                      onClick={() =>
                        getUpdateUnreadChatMessage(
                          value?.type === "group"
                            ? value?.receiverID
                            : authSessionUser?.user_id === value.senderID
                            ? value?.receiverID
                            : value.senderID,
                          "countUpdate",
                        )
                      }
                    >
                      <a className="chat_actions_tag">Mark unread</a>
                    </li>
                    <li
                      className="chat_actions_li"
                      onClick={() => handleUnpinAlert(value)}
                    >
                      <a className="chat_actions_tag">
                        {value?.pinned ? "Unpin" : "Pin"}
                      </a>
                    </li>
                  </ul>
                </div>
              )}
              {showDelete && (
                <ChatDelete
                  showDelete={showDelete}
                  handleClose={() => setShowDelete(false)}
                  deleteData={deleteData}
                  userInfo={userInfo}
                  selectedLanguage={selectedLanguage}
                />
              )}
              {showUnpin && (
                <ChatUnpinAlert
                  showUnpin={showUnpin}
                  handleClose={() => setShowUnpin(false)}
                  unpinData={unpinData}
                  userInfo={userInfo}
                  selectedLanguage={selectedLanguage}
                  handleUnpinMessage={handlePinnedMessage}
                />
              )}
            </div>
          </>
        </div>
        {value?.reactions?.length > 0 && (
          <div className="reactions">
            {value?.reactions?.map((item, index) => (
              <div
                key={index}
                className="position-relative d-flex justify-content-center"
              >
                <a
                  className={`reactions-tag ${
                    item?.user_id?.includes(senderID) ? "active" : ""
                  }`}
                  key={index}
                  onMouseEnter={() =>
                    setSelectedReactionUser({
                      msgID: value?.id,
                      reactionIndex: index,
                      reactionUserId: item?.user_id ?? "",
                      emoji: item.emoji,
                      names: item?.names ?? [],
                    })
                  }
                  onMouseLeave={() => setSelectedReactionUser({})}
                  onClick={() => addRemoveEmoji(item, value)}
                >
                  <span className="mr-1">{item.emoji}</span>
                  {item.count}
                </a>

                {selectedReactionUser &&
                Object.keys(selectedReactionUser).length > 0 &&
                selectedReactionUser?.msgID === value.id &&
                selectedReactionUser?.reactionIndex === index ? (
                  <ReactionUserPopOver
                    selectedReactionUser={selectedReactionUser}
                  />
                ) : null}
              </div>
            ))}
            {value?.reactions?.length > 0 && (
              <div className="position-relative reactions-tag">
                <button
                  type="submit"
                  className="btn-icon"
                  onClick={(e) => openPicker(e)}
                >
                  <EmojiIcon width={15} height={15} />
                </button>
              </div>
            )}
          </div>
        )}
      </div>
      {Boolean(threadCount) && firstMessage && (
        <div className="d-flex align-items-center">
          <p className="pr-3 mb-0 no-whitespace">
            {threadCount} {threadCount > 1 ? "replies" : "reply"}
          </p>
          <hr />
        </div>
      )}
      {emojiOpen &&
        typeof document !== "undefined" &&
        createPortal(
          <div
            ref={emojiPickerRef}
            className="emoji-portal"
            style={{
              top: emojiPosition.top,
              left: emojiPosition.left,
            }}
          >
            <EmojiPicker
              lazyLoadEmojis
              onEmojiClick={(data) => {
                onEmojiClick(data);
                closePicker();
              }}
            />
          </div>,
          document.body,
        )}
    </>
  );
};

export default memo(ThreadBoardOutgoing);
